import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';

const AssistantIntro = () => {
  return (
    <Paper 
      elevation={3}
      sx={{ 
        p: 3,
        mb: 5,
        borderRadius: 3,
        background: 'linear-gradient(to right, #e3f2fd, #ffffff)',
        borderLeft: '6px solid #1976d2',
        boxShadow: '0 3px 8px rgba(0,0,0,0.06)',
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start'
      }}
    >
      <SmartToyIcon sx={{ fontSize: 44, color: '#1976d2', mt: 0.5 }} />

      <Box>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 1 }}>
        Say Hello to Echo
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
  <strong>Hi, I'm Echo </strong> — your intelligent file Assistant. I review reports generated through our file validation agent and will help you answer any questions about the processed files and its associated metrics.
</Typography>


        <Box sx={{ backgroundColor: '#f5f5f5', p: 2, borderRadius: 1, mb: 2 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>🧾 Eligibility files:</strong> Contain member's/Dependents Demographics and Health Plan coverage details.
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>🏥 Medical files:</strong> Includes all the Professional/Institutional Medical claims of the Member's/Dependents.
          </Typography>
          <Typography variant="body2">
            <strong>💊 Pharmacy files:</strong> Record all the prescription drug claims of the Member's/Dependents.
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ color: '#0288d1', fontStyle: 'italic' }}>
          Currently supports <strong>Eligibility</strong> reports. ⭐ Support for <strong>Medical</strong> and <strong>Pharmacy</strong> coming soon.
        </Typography>
      </Box>
    </Paper>
  );
};

export default AssistantIntro;
